import api from "./api";

/* GET ALL DEPARTMENTS */
export const getDepartments = async (params = {}) => {
  const response = await api.get("employees/departments/", { params });
  return response.data;
};

/* GET SINGLE DEPARTMENT */
export const getDepartmentById = async (
  id
) => {
  const response = await api.get(
    `employees/departments/${id}/`
  );

  return response.data;
};

/* CREATE DEPARTMENT */
export const createDepartment = async (
  departmentData
) => {
  const response = await api.post(
    "employees/departments/",
    departmentData
  );

  return response.data;
};

/* UPDATE DEPARTMENT */
export const updateDepartment = async (
  id,
  departmentData
) => {
  const response = await api.put(
    `employees/departments/${id}/`,
    departmentData
  );

  return response.data;
};

/* PARTIAL UPDATE */
export const patchDepartment = async (
  id,
  departmentData
) => {
  const response = await api.patch(
    `employees/departments/${id}/`,
    departmentData
  );

  return response.data;
};

/* DELETE DEPARTMENT */
export const deleteDepartment = async (id, password) => {
  const headers = password ? { "X-Confirm-Password": password } : {};
  const response = await api.delete(`employees/departments/${id}/`, { headers, data: { password }, params: { password } });
  return response.data;
};